import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/Rectangle1.png';
import _imports_1 from '@/assets/images/Rectangle2.png';
import _imports_2 from '@/assets/images/Rectangle3.png';
import _imports_3 from '@/assets/images/Rectangle4.png';
import _imports_4 from '@/assets/images/Rectangle5.png';
import _imports_5 from '@/assets/images/Rectangle6.png';
import _imports_6 from '@/assets/images/Rectangle7.png';
import _imports_7 from '@/assets/images/Rectangle8.png';
const _withScopeId = n => (_pushScopeId("data-v-4b4d6287"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainPage-container"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"system\" data-v-4b4d6287><div class=\"title\" data-v-4b4d6287>规范体系</div><div class=\"content\" data-v-4b4d6287><div class=\"left\" data-v-4b4d6287><div class=\"left-item\" data-v-4b4d6287><div class=\"left-item-title\" data-v-4b4d6287>GLP</div></div><div class=\"left-item\" data-v-4b4d6287><div class=\"left-item-title\" data-v-4b4d6287>CNAS GLP</div></div><div class=\"left-item\" data-v-4b4d6287><div class=\"left-item-title\" data-v-4b4d6287>CNAS</div></div><div class=\"left-item\" data-v-4b4d6287><div class=\"left-item-title\" data-v-4b4d6287>CMA</div></div></div><div class=\"right\" data-v-4b4d6287><div class=\"right-content\" data-v-4b4d6287><div data-v-4b4d6287>数智金源是一家专注于检验检测行业数字化系统的领先企业。数智金源实验室管理系统广泛应用于农药登记试验、新化学物质登记试验、化妆品注册备案检验等领域，涵盖毒理学、产品化学、生态毒理、环境归趋、农药残留、药效、理化检测等多个试验领域。系统符合GLP、CNAS GLP、CNAS、CMA四大国内国际规范体系，确保数据的准确性和可靠性。</div><div data-v-4b4d6287>系统为检验检测行业提供了全面的实验室管理解决方案，致力于为检验检测行业提供高效、可靠、安全的数字化系统解决方案，推动科研工作的顺利进行。</div></div></div></div></div>", 1);
const _hoisted_3 = {
  class: "productCenter"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "产品中心", -1));
const _hoisted_5 = {
  class: "productCenter-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "销售管理", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "试验管理", -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "质量管理", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "物料管理", -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "财务管理", -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "行政管理", -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "仪器数据备份", -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "客户服务系统", -1));
const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "销售管理", -1));
const _hoisted_32 = [_hoisted_30, _hoisted_31];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "试验管理", -1));
const _hoisted_35 = [_hoisted_33, _hoisted_34];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "质量管理", -1));
const _hoisted_38 = [_hoisted_36, _hoisted_37];
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "物料管理", -1));
const _hoisted_41 = [_hoisted_39, _hoisted_40];
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "财务管理", -1));
const _hoisted_44 = [_hoisted_42, _hoisted_43];
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "行政管理", -1));
const _hoisted_47 = [_hoisted_45, _hoisted_46];
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "仪器数据备份", -1));
const _hoisted_50 = [_hoisted_48, _hoisted_49];
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "productCenter-content-row-item-title"
}, "客户服务系统", -1));
const _hoisted_53 = [_hoisted_51, _hoisted_52];
const _hoisted_54 = {
  class: "solution"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "解决方案", -1));
const _hoisted_56 = {
  key: 0,
  class: "carsouel2"
};
const _hoisted_57 = {
  key: 1,
  class: "carsouel3"
};
import { useRouter, useRoute } from 'vue-router';

import { inject } from 'vue';
export default {
  __name: 'mainPage',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const $screenWidth = inject('$screenWidth');
    const $screenSize = inject('$screenSize');
    let topBanner = [{
      src: require("@/assets/images/image133.png")
    }, {
      src: require("@/assets/images/image134.png")
    }, {
      src: require("@/assets/images/image131.png")
    }, {
      src: require("@/assets/images/image132.png")
    }];
    return (_ctx, _cache) => {
      const _component_carousel = _resolveComponent("carousel");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_carousel2 = _resolveComponent("carousel2");
      const _component_carousel3 = _resolveComponent("carousel3");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_carousel, {
        topBanner: _unref(topBanner),
        height: _unref($screenSize) == 'md' ? '560px' : '200px',
        slogn: "出色的研究始于出色的实验室管理",
        subSlogn: "规范专业的实验室管理系统"
      }, null, 8, ["topBanner", "height"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-sm-and-down"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/productCenter/salesManagement'))
          }, _hoisted_8)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/productCenter/trialManagement'))
          }, _hoisted_11)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/productCenter/qualityControl'))
          }, _hoisted_14)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[3] || (_cache[3] = $event => _unref(router).push('/productCenter/materielManagement'))
          }, _hoisted_17)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-sm-and-down"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[4] || (_cache[4] = $event => _unref(router).push('/productCenter/financialManagement'))
          }, _hoisted_20)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[5] || (_cache[5] = $event => _unref(router).push('/productCenter/administrationManagement'))
          }, _hoisted_23)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[6] || (_cache[6] = $event => _unref(router).push('/productCenter/InstrumentDataBackup'))
          }, _hoisted_26)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[7] || (_cache[7] = $event => _unref(router).push('/productCenter/customerServiceSystem'))
          }, _hoisted_29)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-md-and-up"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[8] || (_cache[8] = $event => _unref(router).push('/productCenter/salesManagement'))
          }, _hoisted_32)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[9] || (_cache[9] = $event => _unref(router).push('/productCenter/trialManagement'))
          }, _hoisted_35)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-md-and-up"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[10] || (_cache[10] = $event => _unref(router).push('/productCenter/qualityControl'))
          }, _hoisted_38)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[11] || (_cache[11] = $event => _unref(router).push('/productCenter/materielManagement'))
          }, _hoisted_41)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-md-and-up"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[12] || (_cache[12] = $event => _unref(router).push('/productCenter/financialManagement'))
          }, _hoisted_44)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[13] || (_cache[13] = $event => _unref(router).push('/productCenter/administrationManagement'))
          }, _hoisted_47)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10,
        class: "productCenter-content-row hidden-md-and-up"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[14] || (_cache[14] = $event => _unref(router).push('/productCenter/InstrumentDataBackup'))
          }, _hoisted_50)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "productCenter-content-row-item",
            onClick: _cache[15] || (_cache[15] = $event => _unref(router).push('/productCenter/customerServiceSystem'))
          }, _hoisted_53)]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _unref($screenSize) == 'md' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_carousel2)])) : _createCommentVNode("", true), _unref($screenSize) == 'sm' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createVNode(_component_carousel3)])) : _createCommentVNode("", true)])]);
    };
  }
};